<script setup>
import { onBeforeUnmount, watch } from "vue";
import { X } from "@lucide/vue";

const props = defineProps({
  open: Boolean,
  title: String,
  eyebrow: { type: String, default: "Kayit islemi" },
  description: String,
  size: { type: String, default: "lg" },
});
const emit = defineEmits(["close"]);
function keydown(event) {
  if (event.key === "Escape" && props.open) emit("close");
}
watch(
  () => props.open,
  (value) => document.body.classList.toggle("overflow-hidden", value),
);
document.addEventListener("keydown", keydown);
onBeforeUnmount(() => {
  document.removeEventListener("keydown", keydown);
  document.body.classList.remove("overflow-hidden");
});
</script>

<template>
  <Teleport to="body">
    <Transition name="drawer-backdrop">
      <div v-if="open" class="fixed inset-0 z-[80] bg-ink-950/45 backdrop-blur-[2px]" @mousedown.self="$emit('close')" />
    </Transition>
    <Transition name="drawer-panel">
      <aside
        v-if="open"
        :class="[
          'fixed inset-y-0 right-0 z-[90] flex w-full flex-col bg-white shadow-2xl',
          size === 'xl' ? 'max-w-4xl' : size === 'md' ? 'max-w-xl' : 'max-w-2xl',
        ]"
        role="dialog"
        aria-modal="true"
      >
        <header class="flex min-h-24 items-start gap-4 border-b border-slate-200 px-6 py-5 sm:px-7">
          <div class="min-w-0 flex-1">
            <p class="page-kicker">{{ eyebrow }}</p>
            <h2 class="text-xl font-extrabold text-ink-950">{{ title }}</h2>
            <p v-if="description" class="mt-1 text-sm leading-5 text-slate-500">{{ description }}</p>
          </div>
          <button type="button" class="icon-btn shrink-0" title="Kapat" @click="$emit('close')"><X class="size-5" /></button>
        </header>
        <div class="min-h-0 flex-1 overflow-y-auto px-6 py-6 sm:px-7"><slot /></div>
        <footer v-if="$slots.footer" class="border-t border-slate-200 bg-slate-50/80 px-6 py-4 sm:px-7">
          <div class="flex items-center justify-end gap-2"><slot name="footer" /></div>
        </footer>
      </aside>
    </Transition>
  </Teleport>
</template>

